import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * useIsMobile
 * Hook that returns true when the viewport width is below the mobile breakpoint.
 *
 * @returns {boolean} True if the viewport width is less than MOBILE_BREAKPOINT.
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isMobile;
};

export default useIsMobile;
